import { StopCharges } from '../types';

export const parseYearlyCharge = (value: string): StopCharges | undefined => {
  const parsed = parseInt(value, 10);
  return value !== '' && !isNaN(parsed) ? { yearly: parsed } : undefined;
};
